<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="weight" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="imgUrl" label="banner" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.imgUrl" min-width="70" height="70" />
          </template>
        </el-table-column>
        
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="banner" prop="imgUrl">
                <upload
                  :url.sync="addData.imgUrl"
                  :src="addData.imgUrl"
                  type="img"
                  :width="750"
                  :height="1000"
                ></upload>
                <div style="color: red">*(建议尺寸750px * 1000px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="排序" prop="weight">
                <el-input-number v-model="addData.weight"  :min="0" :max="100" label="描述文字"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="跳转类型" prop="type">
                <el-select
                  v-model="addData.type"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="链接&id" prop="object">
                <el-input
                  v-model="addData.object"
                  placeholder="活动相关填写id，外链:完整链接"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      siteList: [
        {
          id: 0,
          name: "首页顶部",
        },
        {
          id: 1,
          name: "广告位",
        },
        {
          id: 2,
          name: "二手闲置",
        },
        {
          id: 3,
          name: "养老食堂",
        },
      ],
      typeList: [
        {
          id: -1,
          name: "不跳转",
        },
        {
          id: 1,
          name: "活动",
        },
        // {
        //   id: 2,
        //   name: "投票",
        // },
        // {
        //   id: 3,
        //   name: "问卷",
        // },
        // {
        //   id: 4,
        //   name: "外链",
        // },
        // {
        //   id: 5,
        //   name: "图片链接",
        // },
        // {
        //   id: 6,
        //   name: "h5链接",
        // },
        {
          id: 7,
          name: "内部详情",
        },
      ],
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        imgUrl: "",
        type: "",
        object: "",
      },
      addDataRules: {
        imgUrl: [{ required: true, message: "请上传banner", trigger: "blur" }],
        
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    siteType(row) {
      if (row.site == 0) {
        return "首页顶部";
      } else if (row.site == 1) {
        return "广告位";
      } else if (row.site == 2) {
        return "二手闲置";
      } else if (row.site == 3) {
        return "养老食堂";
      }
    },
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.bannerStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.bannerDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            imgUrl: this.addData.imgUrl,
            object: this.addData.object,
            site: 0,
            status: this.addData.status || 1,
            type: this.addData.type,
            weight:this.addData.weight
          };
          this.$Apis.bannerAddup(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
      };
      this.$Apis.bannerList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.status = item.status == 1 ? true : false;
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>